"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SignupSurveyEntEvent = void 0;
// tslint:disable
const BaseAvroRecord_1 = require("../../BaseAvroRecord");
class SignupSurveyEntEvent extends BaseAvroRecord_1.BaseAvroRecord {
    constructor() {
        super(...arguments);
        this.channel = "";
        this.comment = "";
    }
    schema() {
        return SignupSurveyEntEvent.schema;
    }
    subject() {
        return SignupSurveyEntEvent.subject;
    }
}
exports.SignupSurveyEntEvent = SignupSurveyEntEvent;
SignupSurveyEntEvent.subject = "signup-survey-ent-event";
SignupSurveyEntEvent.schema = {
    "type": "record",
    "name": "SignupSurveyEntEvent",
    "namespace": "storyblocks.user",
    "fields": [
        {
            "name": "meta",
            "type": {
                "type": "record",
                "name": "Meta",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "uuid",
                        "type": "string"
                    },
                    {
                        "name": "emitted",
                        "type": {
                            "type": "long",
                            "logicalType": "timestamp-millis"
                        }
                    },
                    {
                        "name": "origin",
                        "type": {
                            "type": "enum",
                            "name": "Origin",
                            "symbols": [
                                "VIDEOBLOCKS",
                                "AUDIOBLOCKS",
                                "GRAPHICSTOCK",
                                "STORYBLOCKS",
                                "STORYBLOCKS_NEXTJS",
                                "CONTRIBUTOR_PORTAL",
                                "TEMPLATE_EDITOR",
                                "ACCOUNT_SERVICE",
                                "BILLING_SERVICE",
                                "CONTENT_SERVICE",
                                "PAYOUT_SERVICE",
                                "TRANSLATION_SERVICE",
                                "CONTENT_RATING_APP",
                                "FEATURE_FLAG_SERVICE",
                                "PREMIERE_PRO_PLUGIN",
                                "AFTER_EFFECTS_PLUGIN",
                                "EXAMPLE_SERVICE",
                                "SEARCH_SERVICE",
                                "CONTENT_JOB",
                                "DATA_JOB",
                                "MISC",
                                "STORYBOARD",
                                "USER_SERVICE",
                                "SUBSCRIPTION_SERVICE",
                                "OUTDATED_SCHEMA"
                            ],
                            "default": "OUTDATED_SCHEMA"
                        }
                    },
                    {
                        "name": "trace",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "TraceContext",
                                "fields": [
                                    {
                                        "name": "traceId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "pageTraceId",
                                        "type": "string",
                                        "default": ""
                                    },
                                    {
                                        "name": "spanId",
                                        "type": "string"
                                    },
                                    {
                                        "name": "parentId",
                                        "type": "string",
                                        "default": ""
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "user",
            "type": {
                "type": "record",
                "name": "User",
                "namespace": "storyblocks.common",
                "fields": [
                    {
                        "name": "visitorCookieId",
                        "type": [
                            "null",
                            "string"
                        ]
                    },
                    {
                        "name": "userId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "subscriptionId",
                        "type": [
                            "null",
                            "int"
                        ]
                    },
                    {
                        "name": "recurlySubscriptionId",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "recurlySubscriptionUuid",
                        "type": [
                            "null",
                            "string"
                        ],
                        "default": null
                    },
                    {
                        "name": "organizationId",
                        "type": [
                            "null",
                            "int"
                        ],
                        "default": null
                    },
                    {
                        "name": "bot",
                        "type": [
                            "null",
                            {
                                "type": "record",
                                "name": "Bot",
                                "fields": [
                                    {
                                        "name": "isBot",
                                        "type": "boolean"
                                    }
                                ]
                            }
                        ],
                        "default": null
                    }
                ]
            }
        },
        {
            "name": "channel",
            "type": "string",
            "default": ""
        },
        {
            "name": "comment",
            "type": "string",
            "default": ""
        }
    ]
};
//# sourceMappingURL=SignupSurveyEntEvent.js.map